import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';

export const usePermissionStore = defineStore('permission', {
  state () {
    return {
      permissionData: [
      ],
      selectedPermissions: []
    };
  },
  getters: {
   getPermissionData () {
     return this.permissionData;
   },
    permissions () {
     return this.permissionData;
    }
  },
  actions: {
    fetchPermissions () {
      ApiService.fetchPortalPermissions().then((response)=>{

        this.permissionData = response.data;

      });
    },
    // todo: consolidate with other getXXById functions
    getPermissionsById (ids) {
      if (ids === undefined) { return []; }

      let arr = [];

      this.permissions.forEach((permission) => {

        let p = this.getIdFromSubscriptionValue(permission.value);

        if (ids.includes(p)) {
          arr.push(permission);
        }

        /* if (ids.includes(permission.subscriptionId)) {
          arr.push(permission);
        }*/

      });
      return arr.sort((a, b) => a.name.localeCompare(b.name));
    },

    getValueFromSubscriptionId (id) {

      let p = this.permissions.find((permission) => permission.subscriptionId === id);
      return p.value;

    },

    getIdFromSubscriptionValue (value) {
      let p = this.permissions.find((permission) => permission.value === value);
      return p.subscriptionId;
    }
  },
});
